import { DollarSign, LayoutGrid, ShieldCheck, Timer } from "lucide-react";
import { useSiteSettings } from "../../contexts/SiteSettingsContext";
import { useSiteT } from "../../hooks/useSiteT";

export default function StatsSection() {
    const { settings } = useSiteSettings();
    const { t } = useSiteT();
    const stats = [
        { key: "ad-spend-managed", value: settings.stats_ad_spend, label: t("st.spend"), Icon: DollarSign },
        { key: "accounts-issued", value: settings.stats_accounts, label: t("st.accounts"), Icon: LayoutGrid },
        { key: "operational-uptime", value: settings.stats_bans, label: t("st.uptime"), Icon: ShieldCheck },
        { key: "provisioning-time", value: settings.stats_provisioning, label: t("st.provisioning"), Icon: Timer },
    ];
    return (
        <section data-testid="stats-section" className="py-16 md:py-20">
            <div className="container-skala">
                <div className="relative rounded-3xl border border-white/[0.08] bg-card overflow-hidden">
                    <div className="absolute top-0 inset-x-0 h-px" style={{ background: "linear-gradient(90deg, transparent, hsl(158 42% 46%), transparent)" }} />
                    <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-y md:divide-y-0 divide-white/[0.06]">
                        {stats.map((s) => (
                            <div key={s.key} data-testid={`stat-${s.key}`} className="p-8 md:p-10">
                                <s.Icon className="w-5 h-5 text-primary/80 mb-4" />
                                <div className="font-display font-bold text-4xl md:text-5xl text-foreground tabular-nums">{s.value}</div>
                                <div className="mt-2 text-[11px] font-mono uppercase tracking-[0.22em] text-muted-foreground">{s.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
